import { QRCodeSVG } from "qrcode.react";

export interface QRCodeProps {
  /** The value to encode (URL, secret, etc.). */
  value:      string;
  /** Pixel size of the SVG square. Defaults to 180. */
  size?:      number;
  className?: string;
}

/**
 * Renders a QR code as an inline SVG (no canvas, works in SSR-safe mode).
 * Background is transparent so it adapts to the surface color.
 */
export function QRCode({ value, size = 180, className }: QRCodeProps) {
  return (
    <QRCodeSVG
      value={value}
      size={size}
      bgColor="transparent"
      fgColor="var(--color-fg)"
      level="M"
      className={className}
    />
  );
}
